(function () {
  'use strict';

  angular.module('wsLrs.controllers').factory("DefaultCardGroups", ['$http', '$q', 'Api', 'CardGroup', 'CardRegistry', 'Dashboards', 'User', 'ViewDashboardsAs', function ($http, $q, Api, CardGroup, CardRegistry, Dashboards, User, ViewDashboardsAs) {
    return {
      _cachedResults: {},
      getDefaultCardGroupNames: function getDefaultCardGroupNames() {
        return ["Dashboard", "Your Reports"];
      },
      ensureExist: function ensureExist() {
        var self = this,
          user = User.get().user,
          organization = User.get().organization,
          orgId = organization.id;
        var userId = user.id;

        // Override user id with any impersonated user, if that feature is active
        if (ViewDashboardsAs.isActive && ViewDashboardsAs.selectedUser) {
          userId = ViewDashboardsAs.selectedUser.id;
        }
        var cacheKey = orgId + "|" + userId;
        if (!self._cachedResults[cacheKey]) {
          var url = Api.url("/card-groups/ensure-default-groups"),
            params = {
              "user.id": userId
            };
          var request = Dashboards.get().then(function () {
            return $http.post(url, null, {
              params: params
            });
          });
          self._cachedResults[cacheKey] = request.then(function (response) {
            var groups = response.data.results;
            return _.object(_.map(groups, function (group) {
              return [group.name, group];
            }));
          });
        }
        return this._cachedResults[cacheKey];
      },
      _pair: function _pair(cardGroup, card) {
        cardGroup.cardIds = cardGroup.cardIds || [];
        if (!_.contains(cardGroup.cardIds, card.id)) {
          cardGroup.cardIds.push(card.id);
        }
        card.cardGroupIds = card.cardGroupIds || [];
        if (!_.contains(card.cardGroupIds, cardGroup.id)) {
          card.cardGroupIds.push(cardGroup.id);
        }
      },
      addToDefaultGroups: function addToDefaultGroups(cards) {
        var self = this;

        // First, ensure that our default groups exist...
        return this.ensureExist().then(function (groupMap) {
          var userId = User.get().user.id;

          // Override user id with any impersonated user, if that feature is active
          if (ViewDashboardsAs.isActive && ViewDashboardsAs.selectedUser) {
            userId = ViewDashboardsAs.selectedUser.id;
          }

          // / Then figure out the groups that belong to us...
          return CardGroup.list({
            "user.id": userId
          }).then(function (resultList) {
            var userCardGroupIds = _.map(resultList.results, function (g) {
              return g.id;
            });
            var groupsToSave = [];
            _.each(cards, function (card) {
              card = CardRegistry.get(card.id);

              // If the given card is already in a group...
              if (!_.isEmpty(card.cardGroupIds)) {
                // If it's not a me card, being in a group means we can skip it
                if (card.template.cardType !== "me") {
                  return;
                }

                // But if it's a me card, make sure it's in one of the user's groups... 
                var containingGroupId = _.find(userCardGroupIds, function (groupId) {
                  return _.contains(card.cardGroupIds, groupId);
                });

                // If it's already in one of the user's groups, skip it
                if (containingGroupId) {
                  return;
                }
              }

              // Otherwise, figure out this card's default group
              self._pair(groupMap[self.getDefaultDashboardForCardType(card.template.cardType)], card);
              groupsToSave.push(self.getDefaultDashboardForCardType(card.template.cardType));
            });
            groupsToSave = _.uniq(groupsToSave);
            var promises = _.map(groupsToSave, function (groupName) {
              return CardGroup.save(groupMap[groupName]);
            });
            return $q.all(promises).then(function () {
              return groupMap;
            });
          });
        });
      },
      getDefaultDashboardForCardType: function getDefaultDashboardForCardType(cardType) {
        if (cardType === "activity") {
          return "Dashboard";
        } else if (cardType === "me") {
          return "Your Reports";
        }
        return null;
      },
      clearCache: function clearCache() {
        this._cachedResults = {};
        Dashboards.clearCache();
      }
    };
  }]).factory("DefaultCardGroupControl", ['$q', 'Alerts', 'Card', 'CardRegistry', 'CardGroup', 'CardGroupControl', function ($q, Alerts, Card, CardRegistry, CardGroup, CardGroupControl) {
    // TODO: Does this even provide any value?
    return {
      deleteCard: CardGroupControl.deleteCard,
      adoptCard: CardGroupControl.adoptCard,
      exploreCard: CardGroupControl.exploreCard,
      advancedConfig: CardGroupControl.advancedConfig,
      dashboards: CardGroupControl.dashboards,
      renameCard: CardGroupControl.renameCard
    };
  }]);
})();
